import { MixtureChooseEnum } from "../entities/Mixture";

export const isCheckoutHandlerDisabled = (
  calculationError: boolean,
  isLoading: boolean,
  mixtureOption: MixtureChooseEnum,
  totalPercentage: number,
  initialCalculationIsCompleted: boolean,
) => {
  if (calculationError) {
    return true;
  }

  if (isLoading) {
    return true;
  }

  if (
    mixtureOption === MixtureChooseEnum.PERCENTAGE &&
    totalPercentage !== 100
  ) {
    return true;
  }

  if (!initialCalculationIsCompleted) {
    return true;
  }

  return false;
};
